import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import Vuelidate from 'vuelidate'
// index.js or main.js
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueLocalForage from 'vue-localforage'
import 'babel-polyfill'

Vue.use(VueLocalForage)
//Vue.use(Vuetify)
if (!Array.from) Array.from = require("array-from");
Vue.config.productionTip = false
Vue.use(Vuelidate)

Vue.use(Vuetify, {
  theme: {
    primary: '#932C28',
    secondary: '#4EA6FF',
    terciary: '#EA9F12',
    carregando: '#EA9F12',
    acent2: '#932C28',
    error: '#F50057',
    info: '#80D8FF',
    sucesso: "#00C853"
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js